module.exports = {
      id: "toast-info-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#toast-info",
      toString: function () {
        return this.url;
      }
    }